import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';
import '../../styles/Admin.css';

function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/admin';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-root">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <div className="admin-login-logo-wrap">
            <img
              src={`${process.env.PUBLIC_URL || ''}/logo-tmstudio.png`}
              alt="TM Studio"
              className="admin-login-logo"
            />
          </div>
          <h1 className="admin-login-title">
            <span className="admin-login-title-tm">TM</span> Studio
          </h1>
          <p className="admin-login-subtitle">Panel de administración</p>
        </div>
        <form onSubmit={handleSubmit} className="admin-login-form">
          {error && (
            <div className="admin-login-error" role="alert">
              {error}
            </div>
          )}
          <label className="admin-login-label" htmlFor="admin-email">
            Email
          </label>
          <input
            id="admin-email"
            type="email"
            className="admin-login-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@tmstudio.com"
            required
            autoComplete="email"
          />
          <label className="admin-login-label" htmlFor="admin-password">
            Contraseña
          </label>
          <input
            id="admin-password"
            type="password"
            className="admin-login-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
            autoComplete="current-password"
          />
          <button type="submit" className="admin-login-btn" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLoginPage;
